import { render } from "./UpdateCallQueueDetailForm.vue?vue&type=template&id=bcd4f57e"
import script from "./UpdateCallQueueDetailForm.vue?vue&type=script&lang=js"
export * from "./UpdateCallQueueDetailForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__